import React, { useState } from 'react';

interface Loin{
    email:string
    password:string
    first_name:string
    last_name:string
}
function UseSend({email,password,first_name,last_name}:Loin) {
  const [data, setData] = useState([]);
  const [error,setError] =useState([])
  const [message,setMessage] = useState([])

  async function getData() {
    try {
      const response = await fetch('https://djangodrf.arifsultani291.digital/signup/',{
      method:'POST',
      headers:{ 'Content-Type': 'application/json'},
      body:JSON.stringify({
        email:email,
        password:password,
        first_name:first_name,
        last_name:last_name
      })
    });

      if (!response.ok) {
        const jsonData = await response.json();
        if(jsonData.email){
          setError(jsonData.email)

        }
        if(jsonData.detail){
          setError(jsonData.detail)
        }
        
        if(jsonData.first_name){
          setError(jsonData.first_name)
        }
        if(jsonData.last_name){
          setError(jsonData.last_name)
        }
        console.error('Failed to fetch data. Server responded with:', jsonData);
        return;
      }

      const jsonData = await response.json();
      setData(jsonData);
      setMessage(jsonData.message)
    } catch (error:any) {
      console.error('An error occurred while fetching data:', error.message);
    }
  }

  return { data, getData,error,message };
}

export default UseSend;